import { IActivityHistoryItem } from "../model";
import { Spec } from "./spec";

export class FalseSpec extends Spec<IActivityHistoryItem> {
  isSatisfiedBy(): boolean {
    return false;
  }
}
